import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { siteConfig } from '../data/mock';

const TermsPage = () => {
  return (
    <main>
      <div className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <ChevronRight size={16} />
            <span>Terms of Use</span>
          </div>
          <h1 className="display-medium">Terms of Use</h1>
          <p className="body-large">Terms and conditions for using our website and services.</p>
        </div>
      </div>

      <section className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="network-card" style={{ padding: '40px' }}>
            <p className="body-small" style={{ marginBottom: '32px' }}>Last updated: August 2025</p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. About These Terms</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              These terms of use govern your use of The Grazing Trust (SCIO) website. By accessing or using our website, you agree to be bound by these terms. If you do not agree with any part of these terms, please do not use our website.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. About Us</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              The Grazing Trust is a Scottish Charitable Incorporated Organisation (SCIO) registered with the Office of the Scottish Charity Regulator (OSCR). Registration number: {siteConfig.oscrRegNo}.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Use of Website</h2>
            <p className="body-medium" style={{ marginBottom: '12px' }}>You agree to use this website only for lawful purposes. You must not:</p>
            <ul style={{ paddingLeft: '20px', marginBottom: '24px' }}>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Use the site in any way that breaches applicable laws or regulations</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Use the site in any way that is fraudulent or harmful</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Transmit any material that is defamatory, offensive, or otherwise objectionable</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Attempt to gain unauthorised access to any part of the site</li>
              <li className="body-medium">Interfere with the proper working of the site</li>
            </ul>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Intellectual Property</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              All content on this website, including text, graphics, logos, images, and software, is the property of The Grazing Trust or its content suppliers and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works from this content without our written permission.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Submissions</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              When you submit information through our forms (such as enquiries, applications, or reports), you confirm that the information provided is accurate and complete to the best of your knowledge. You agree that we may use this information in accordance with our Privacy Policy.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>6. No Guarantees</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              Submitting an enquiry or application through our website does not guarantee acceptance into any of our programmes. All applications are assessed on a case-by-case basis. We reserve the right to decline any application at our discretion.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>7. Links to Other Websites</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              Our website may contain links to third-party websites. These links are provided for your convenience only. We have no control over the content of linked sites and accept no responsibility for them or for any loss or damage that may arise from your use of them.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>8. Limitation of Liability</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              The information on this website is provided &quot;as is&quot; without any representations or warranties, express or implied. We do not warrant that the website will be available uninterrupted or error-free. To the maximum extent permitted by law, we exclude all liability for any loss or damage arising from your use of this website.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>9. Donations</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              Donations made to The Grazing Trust are voluntary gifts to support our charitable work. Unless otherwise specified, donations are unrestricted and will be used where most needed. Donations are not refundable except in cases of error.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>10. Changes to Terms</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We may revise these terms at any time by updating this page. Please check this page regularly to ensure you are aware of any changes. Your continued use of the website following any changes constitutes acceptance of the revised terms.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>11. Governing Law</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              These terms are governed by the laws of Scotland. Any disputes arising from or relating to these terms or your use of the website will be subject to the exclusive jurisdiction of the Scottish courts.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>12. Contact</h2>
            <p className="body-medium">
              For questions about these terms, contact us at:<br />
              <strong>{siteConfig.name}</strong><br />
              Email: {siteConfig.email}<br />
              {siteConfig.address}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsPage;
